import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { 
  Trophy, 
  Code2, 
  BarChart2, 
  Workflow, 
  Lightbulb, 
  HandshakeIcon 
} from 'lucide-react';
import './WhyUseSection.css';

const WhyUseSection = () => {
  const whyUseRow1 = [
    {
      Icon: Trophy,
      title: "Proven Industry Expertise",
      description: "With over 15 years in AI development and consulting, we've successfully delivered 160+ transformative projects across multiple industries. Our team of 100+ AI specialists combines deep technical knowledge with practical business acumen, ensuring solutions that drive real ROI. From Fortune 500 companies to innovative startups, we've consistently delivered results that exceed expectations."
    },
    {
      Icon: Code2,
      title: "Cutting-Edge Technical Excellence",
      description: "Our technical prowess spans the entire AI development stack. We maintain expertise in: Advanced ML frameworks (TensorFlow, PyTorch, JAX), Latest foundation models (GPT-4, PaLM 2, Llama 2, Claude), Enterprise data platforms (Hadoop, Spark, Snowflake), Cloud infrastructure (AWS, GCP, Azure), and Custom AI model development and optimization. Every solution we build leverages best-in-class technologies and follows industry best practices."
    },
    {
      Icon: BarChart2,
      title: "Results-Driven Partnership",
      description: "We measure our success by your business outcomes. Our approach includes: Dedicated teams aligned with your goals, Regular progress tracking and transparency, Flexible engagement models, Knowledge transfer and team enablement, and Ongoing support and optimization. Your success is our primary metric, and we're committed to delivering measurable value at every step."
    }
  ];

  const whyUseRow2 = [
    {
      Icon: Workflow,
      title: "End-to-End Transformation",
      description: "We go beyond technical implementation to drive comprehensive organizational change: Business process optimization, Team upskilling and training, Change management support, Data culture development, and Infrastructure modernization. Our holistic approach ensures sustainable, long-term success with AI initiatives."
    },
    {
      Icon: Lightbulb,
      title: "Innovation Leadership",
      description: "Stay ahead with our forward-thinking approach: Proprietary AI development frameworks, Agile and iterative implementation, Continuous research and development, Early access to emerging technologies, and Industry-specific innovation labs. We don't just follow best practices – we help create them."
    },
    {
      Icon: HandshakeIcon,
      title: "Long-Term Partnership",
      description: "Build lasting success with a partner who's invested in your growth: Dedicated account teams, Proactive optimization and updates, Regular strategy reviews, Scaling support as you grow, and Technology roadmap guidance. We're committed to your long-term success, not just project completion."
    }
  ];

  return (
    <section className="whyuse-section">
      <Container>
        <h2 className="section-title">Why Choose Us</h2>
        <Row className="mb-4">
          {whyUseRow1.map((item, index) => (
            <Col md={4} key={index} className="whyuse-col">
              <div className="whyuse-card">
                <item.Icon className="whyuse-icon" size={32} />
                <h3 className="whyuse-title">{item.title}</h3>
                <p className="whyuse-description">{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
        <Row>
          {whyUseRow2.map((item, index) => (
            <Col md={4} key={index} className="whyuse-col">
              <div className="whyuse-card">
                <item.Icon className="whyuse-icon" size={32} />
                <h3 className="whyuse-title">{item.title}</h3>
                <p className="whyuse-description">{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default WhyUseSection;